import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            error: null,
        };
    }

    public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Unhandled application error", error, errorInfo);
    }

    public render() {
        const { error } = this.state;

        if (!error) {
            return this.props.children;
        }

        return (
            <Box
                sx={{
                    minHeight: "100dvh",
                    display: "grid",
                    placeItems: "center",
                    padding: 3,
                }}
            >
                <Paper sx={{ maxWidth: 560, width: "100%", padding: 4 }}>
                    <Stack spacing={2.5}>
                        <Typography variant="overline" color="primary.main">
                            Системна грешка
                        </Typography>
                        <Typography variant="h4">
                            Нещо в приложението се счупи неочаквано.
                        </Typography>
                        <Alert severity="error">
                            Екранът беше спрян, за да не остане приложението в невалидно състояние.
                        </Alert>
                        <Typography color="text.secondary">
                            Можеш да презаредиш страницата. Ако проблемът се повтори, се обади на програмистите.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => window.location.reload()}
                        >
                            Презареди
                        </Button>
                    </Stack>
                </Paper>
            </Box>
        );
    }
}
